/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TargetRadialIcon32Regular = forwardRef('TargetRadialIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16 12a4 4 0 1 0 0 8 4 4 0 0 0 0-8Zm-2 4a2 2 0 1 1 4 0 2 2 0 0 1-4 0Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.5 16a8.5 8.5 0 1 1 17 0 8.5 8.5 0 0 1-17 0ZM16 9.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3 16C3 8.82 8.82 3 16 3s13 5.82 13 13-5.82 13-13 13S3 23.18 3 16ZM16 5C9.925 5 5 9.925 5 16s4.925 11 11 11 11-4.925 11-11S22.075 5 16 5Z" })));
});
